import pt from '@/i18n/pt/'

const messages = {
  pt
}

export default messages